import React from "react";
import "./StatCard.css";

const StatCard = ({ 
    icon, 
    iconColor = "pink", 
    value, 
    label, 
    trend, 
    trendDirection, 
    trendLabel,
    isPrimary = false,
    isLoading = false,
    currencySymbol = "$"
}) => {
    const formatValue = (val) => {
        if (isLoading || val === undefined || val === null) {
            return "...";
        }
        if (typeof val === 'number') {
            return val.toLocaleString();
        }
        return val;
    };

    return (
        <div className={`stat-card ${isPrimary ? 'stat-card-primary' : ''}`}>
            <div className="stat-card-header">
                <div className={`stat-card-icon ${isPrimary ? '' : iconColor}`}>
                    <i className={icon}></i>
                </div>
            </div>
            <div className="stat-card-value">
                {formatValue(value)}
            </div>
            <div className="stat-card-label">{label}</div>
            {(trend || trendLabel) && (
                <div className={`stat-card-trend ${trendDirection || ''}`}>
                    {trendDirection === 'up' && <i className="fa fa-arrow-up"></i>}
                    {trendDirection === 'down' && <i className="fa fa-arrow-down"></i>}
                    {trend && <span>{trend}</span>}
                    {trendLabel && <span>{trendLabel}</span>}
                </div>
            )}
        </div>
    );
};

export default StatCard;
